import React, {Component} from 'react'
import {change, startAsyncValidation} from 'redux-form'
import PropTypes from 'prop-types'
import {resolve} from '@cred/shared/utils'
import Analytics from '@cred/react-analytics'
import withForm from '@cred/shared/hoc/with-form'
import {compose} from 'redux'
import config from 'config'
import SchoolSearch from '../school-search'
import {Input, textInputWithAnalytics, hiddenInput} from '../components'

/**
 * @visibleName Full School
 */
class FullSchool extends Component {
  static propTypes = {
    name: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    autoFocus: PropTypes.bool,
    analyticsContexts: PropTypes.array,
    analyticsOptions: PropTypes.object,
    fieldNameStyle: PropTypes.oneOf(['snake', 'camel']),
    otherSchoolText: PropTypes.string,
    baseUrl: PropTypes.string,
    endpointPath: PropTypes.string,
    extraQueryParams: PropTypes.object,
    hideOtherInput: PropTypes.bool
  }

  static defaultProps = {
    autoFocus: false,
    analyticsContexts: [],
    analyticsOptions: null,
    fieldNameStyle: 'snake',
    hideOtherInput: false,
    otherSchoolText: 'Other - school not listed',
    baseUrl: config.searchSchoolsBaseUrl,
    endpointPath: config.searchSchoolsEndpointUrl,
    extraQueryParams: {}
  }

  constructor(props) {
    super(props)

    const {formData, name} = props

    this.selectedSchoolFlag = !!resolve(`values.${name}.name`, formData)
    this.state = {lastSelectedSchool: resolve(`values.${name}.name`, formData)}
    this.analytics = new Analytics(props.analytics)
  }

  getFieldName = field => {
    const {fieldNameStyle} = this.props

    switch (field) {
      case 'key':
        return fieldNameStyle === 'snake' ? 'key' : 'schoolKey'
      case 'other':
        return fieldNameStyle === 'snake' ? 'other' : 'otherSchool'
    }
  }

  handleSelectSchool = schoolData => {
    const {name, dispatch, formName} = this.props

    this.selectedSchoolFlag = true

    dispatch(change(formName, `${name}.${this.getFieldName('key')}`, schoolData.school_key))
    dispatch(change(formName, `${name}.name`, schoolData.institution_name))
    dispatch(startAsyncValidation(formName))

    this.setState({lastSelectedSchool: schoolData.institution_name})

    setTimeout(() => {
      const {name, title} = this.props

      this.analytics.event({
        name,
        value: schoolData.institution_name,
        title,
        error: null
      })
    }, 0)
  }

  handleFullSchoolBlur = e => {
    const {name, dispatch, formName} = this.props

    dispatch(change(formName, `${name}.name`, this.state.lastSelectedSchool ? this.state.lastSelectedSchool : null))
    e.preventDefault()
  }

  /* Avoid having the field validated if the user added only
   * part of a school name without selecting it from the dropdown. */
  selectedSchool = () => {
    const {validate} = this.props

    let error

    /* Only validates it if there is other validation. */
    if (validate && !this.selectedSchoolFlag) {
      error = 'Please complete this field'
    }

    return error
  }

  render() {
    const {
        name,
        title,
        hideOtherInput,
        otherSchoolLabel,
        otherSchoolPlaceholder,
        validate,
        className,
        autoFocus,
        focusAfter,
        formData,
        analyticsContexts,
        analyticsOptions,
        otherSchoolText,
        baseUrl,
        endpointPath,
        extraQueryParams
      } = this.props,
      other =
        resolve(`values.${name}.name`, formData) === otherSchoolText

    return (
      <div className={className}>
        <div>
          <SchoolSearch
            name={`${name}.name`}
            autoFocus={autoFocus}
            focusAfter={focusAfter}
            label={title}
            onSelectSchool={this.handleSelectSchool}
            onBlur={this.handleFullSchoolBlur}
            validate={validate && [validate, this.selectedSchool]}
            otherSchoolText={otherSchoolText}
            baseUrl={baseUrl}
            endpointPath={endpointPath}
            extraQueryParams={extraQueryParams}
          />
          <Input component={hiddenInput} name={`${name}.${this.getFieldName('key')}`}/>
        </div>
        {other && !hideOtherInput ?
          <div>
            <Input
              type="text"
              label={otherSchoolLabel}
              placeholder={otherSchoolPlaceholder}
              autoFocus={autoFocus}
              focusAfter={1}
              name={`${name}.${this.getFieldName('other')}`}
              validate={validate}
              className="mt-16"
              component={textInputWithAnalytics}
              analyticsContexts={analyticsContexts}
              analyticsOptions={analyticsOptions}
            />
          </div>
          :
          ''
        }
      </div>
    )
  }
}

export {FullSchool}

export default compose(withForm)(FullSchool)
